import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { ApiResponse, Context, StudyPlanTargets, Transitions } from "../types"
import { getServiceErrorMessage } from "../helpers"

export const getCurrentPlanTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  entry: assign<Context>({ loading: true }),
  exit: assign<Context>({ loading: false }),
  invoke: {
    id: "getCurrentPlan",
    src: "getCurrentPlan",
    onDone: [
      {
        target: "#StudyPlan.teacher_view.lesson_detail_view",
        actions: assign<Context, DoneInvokeEvent<ApiResponse>>((_ctx, evt) => ({
          publishedStudyPlan: evt.data?.response.plan,
          selectedPlanId: evt.data?.response.plan.id
        })),
        cond: ctx =>
          ctx.selfRefScope.scope === "TEACHER" && ctx.lessonDetailViewModal
      },
      {
        target: "#StudyPlan.teacher_view.idle",
        actions: assign<Context, DoneInvokeEvent<ApiResponse>>((_ctx, evt) => ({
          publishedStudyPlan: evt.data?.response.plan,
          selectedPlanId: evt.data?.response.plan.id,
          ...(evt.data?.event?.type === "FETCH_PLAN_BY_REF_SCOPE" && {
            expanded: []
          })
        })),
        cond: ctx => ctx.selfRefScope.scope === "TEACHER"
      },
      {
        target: "#StudyPlan.review_plan.idle",
        actions: assign<Context, DoneInvokeEvent<ApiResponse>>((_ctx, evt) => ({
          publishedStudyPlan: evt.data?.response.plan,
          selectedPlanId: evt.data?.response.plan.id
        })),
        cond: (ctx, response: DoneInvokeEvent<ApiResponse>) => {
          return (
            ctx.currentTarget === "review_plan" ||
            response.data?.event?.type === "FETCH_PLAN_BY_REF_SCOPE" ||
            response.data?.event?.type === "SELECT_USER" ||
            response.data?.event?.type ===
              "done.invoke.restoreToRecommendedPlan"
          )
        }
      },
      {
        target: "#StudyPlan.study_plans_overview.idle",
        actions: assign<Context, DoneInvokeEvent<ApiResponse>>((_ctx, evt) => ({
          publishedStudyPlan: evt.data?.response?.plan,
          selectedPlanId: evt.data?.response?.plan.id
        }))
      }
    ],
    onError: [
      {
        target: "#StudyPlan.study_plans_overview",
        actions: assign<Context, DoneInvokeEvent<ApiResponse>>({
          snackbar: (_ctx, evt) => ({
            message: getServiceErrorMessage("getCurrentPlan", {
              errorReason: evt.data.response,
              messageData: ["view this plan"]
            }),
            withUndo: false,
            error: true
          })
        }),
        cond: ctx =>
          (ctx.selfRefScope.scope === "DISTRICT" ||
            ctx.selfRefScope.scope === "SCHOOL") &&
          ctx.currentTarget === StudyPlanTargets.Overview
      },
      {
        // For read-only apps (WorkKeys), go to study_plans_overview on error
        target: "#StudyPlan.study_plans_overview.idle",
        actions: assign<Context, DoneInvokeEvent<ApiResponse>>({
          snackbar: (_ctx, evt) => ({
            message: getServiceErrorMessage("getCurrentPlan", {
              errorReason: evt.data.response,
              messageData: ["view this plan"]
            }),
            withUndo: false,
            error: true
          })
        }),
        cond: ctx =>
          ctx.isReadOnly &&
          (ctx.selfRefScope.scope === "DISTRICT" ||
            ctx.selfRefScope.scope === "SCHOOL")
      },
      {
        target: "#StudyPlan.landing_view",
        actions: assign<Context, DoneInvokeEvent<ApiResponse>>({
          snackbar: (_ctx, evt) => ({
            message: getServiceErrorMessage("getCurrentPlan", {
              errorReason: evt.data.response,
              messageData: ["view this plan"]
            }),
            withUndo: false,
            error: true
          })
        }),
        cond: ctx =>
          !ctx.isReadOnly &&
          (ctx.selfRefScope.scope === "DISTRICT" ||
            ctx.selfRefScope.scope === "SCHOOL")
      },
      {
        target: "#StudyPlan.teacher_view.idle",
        actions: assign<Context, DoneInvokeEvent<ApiResponse>>({
          snackbar: (_ctx, evt) => ({
            message: getServiceErrorMessage("getCurrentPlan", {
              errorReason: evt.data.response,
              messageData: ["view this plan"]
            }),
            withUndo: false,
            error: true
          })
        }),
        cond: ctx => ctx.selfRefScope.scope === "TEACHER"
      }
    ]
  }
}
